import { Injectable, signal } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class ReportNotesNavigationService {
    private readonly hasBenchmarkingDataSignal = signal<boolean>(true);

    public getHasBenchmarkingData() {
        return this.hasBenchmarkingDataSignal;
    }

    public setHasBenchmarkingData(hasBenchmarkingData: boolean): void {
        this.hasBenchmarkingDataSignal.set(hasBenchmarkingData);
    }
}
